export const PAY_OR_CONSENT_UPSELL_URL = '/purchase/premium';
export const PAY_OR_CONSENT_UPSELL_MID = 'web_test_consent_upsell';
export const PAY_OR_CONSENT_UPSELL_REAGENT = 'uplt_1072';
export const PAY_OR_CONSENT_UPSELL_HREF = `${PAY_OR_CONSENT_UPSELL_URL}?mid=${PAY_OR_CONSENT_UPSELL_MID}&reagent=${PAY_OR_CONSENT_UPSELL_REAGENT}`;
